import moment from 'moment';

export const FEEDBACK_KEY = 'news_feedback_date';

export const getFeedbackStorageKey = () => {
  const now = moment();
  const feedbackDate = now.hour() < 6 ? now.subtract(1, 'day') : now;
  return feedbackDate.format('YYYY-MM-DD');
};

export const getStoredFeedback = (): 'satisfying' | 'disappointing' | null => {
  const key = getFeedbackStorageKey();
  const stored = localStorage.getItem(FEEDBACK_KEY);
  const parsed = stored ? JSON.parse(stored) : null;
  return parsed?.date === key ? parsed.value : null;
};

export const storeFeedback = (value: 'satisfying' | 'disappointing') => {
  const key = getFeedbackStorageKey();
  localStorage.setItem(FEEDBACK_KEY, JSON.stringify({ date: key, value }));
};
